<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/case">产品介绍</el-menu-item>
          <el-menu-item index="/download">微信公众号&小程序</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>联系我们</p>
              <span>邮箱：gaojiechuan@foxmail.com</span>
              <span>手机：13732630869</span>
              <span>地址：盛泽镇东方大街北侧东方中路298号</span>
            </li>
          </ul>
          <img src="./assets/img/gzh.png" alt />
          <img src="./assets/img/ercode.png" alt />
        </div>
        <div class="copyright">
          <span>云盛之芯版权所有</span>
        </div>
      </div>
      <div  style="color: white;display: flex;flex-direction: row;justify-content: center;background-color: #1F357D;padding: 20px">
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" style="color: #07909D">苏ICP备2020061776号-1</a>
        <div>版权所有：苏州云盛之芯信息科技有限公司  ©2020 yunshengzhixin.com | All Rights Reserved</div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #07909D;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    display: flex;
    align-content: stretch;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #1F357D;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
